import router from '@/router'
import server from '@/utils/request'
import api from '@/api'
import {
  getToken,
  setToken,
  removeToken,
  getUserName,
  setUserName,
  removeUserName,
  getMenus,
  setMenus,
  removeMenus
} from '@/utils/auth'
import {Message} from 'element-ui'

const user = {
  state: {
    token: getToken(),
    name: window.localStorage.getItem('names') || '',
    menus: '',
    loginName: window.sessionStorage.getItem('loginName') || ''
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_MENUS: (state, menus) => {
      state.menus = menus
    },
    SET_LOGINNAME: (state, menus) => {
      state.loginName = menus
    }
  },

  actions: {
    // 登录
    Login({commit}, userInfo) {
      const username = userInfo.username.trim();
      return new Promise((resolve, reject) => {
        let pass = userInfo.password;
        // server.post(api.login.sign + "?auth_type=password&clientId=post-loan-back&username=" + username + "&password=" + userInfo.password).then(data => {
        server.post(api.login.sign,{"loginName":username,"password":userInfo.password}).then(data => {
          // console.log(data);
//        记录账号
          window.sessionStorage.setItem('loginName', username);
          commit('SET_LOGINNAME', username);
          localStorage.setItem('sessionId',data.sessionId);
          if (data.resultCode == '0000' && data.state == '0') {
            setToken(data.appToken);
            commit('SET_TOKEN', data.appToken);
//          setUserName(data.user.realName);
            window.localStorage.setItem('names', data.user.realName);
            commit('SET_NAME', data.user.realName);
            server.post(api.login.getMenus,{"sessionId":data.sessionId}).then(res => {
              // console.log(res);
              setMenus(JSON.stringify(res.menuMap));
              commit('SET_MENUS', JSON.stringify(res.menuMap));
              router.push({path: '/welcome'});
            })
          } else if (data.resultCode == '0000' && data.state == '1') {
            setToken(data.appToken);
            commit('SET_TOKEN', data.appToken);
            window.sessionStorage.setItem("pass", pass);
            window.sessionStorage.setItem("userId", data.user.id);
          } else if (data.resultCode == '1000') {
            userInfo.warnInfo = data.resultMsg;
          } else {
            userInfo.warnInfo = '账户或密码错误,请重新输入';
          }
          resolve();
        }).catch(error => {
          reject(error);
        })
      })
    },

    // 获取用户权限
    GetInfo({commit}, data) {
      commit('SET_MENUS', data);
    },

    // 登出
    LogOut({commit}) {
      return new Promise((resolve, reject) => {
        server.get(api.login.signOut).then(response => {
          if (response.resultCode === "0000") {
            commit('SET_TOKEN', '');
            commit('SET_MENUS', []);
            removeToken();
            removeUserName();
            removeMenus();
          }
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 退出
    clear({commit}) {
      commit('SET_TOKEN', '');
      commit('SET_MENUS', []);
      removeToken();
      removeUserName();
      removeMenus();
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js